import type { User } from '@/@types/user'
import { css } from '@emotion/react'
import type { HTMLAttributes } from 'react'
import Avatar from '../../Avatar'
import PostHeader from '../PostHeader'

export interface UserCardProps extends HTMLAttributes<HTMLDivElement> {
	data: User | undefined
}

export default function UserCard({ data, ...props }: UserCardProps) {
	if (!data) return null
	return (
		<div
			css={css`
				display: grid;
				grid-template-columns: auto 1fr;
				gap: 10px;
				background-color: var(--bg-on-body-2);
				padding: 10px;
				border-radius: 10px;
			`}
			{...props}
		>
			<Avatar
				as="div"
				data={data}
				css={css`
					margin: 4px 0;
				`}
			/>

			<PostHeader
				title={data?.screenName}
				desc={
					<div
						css={css`
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						`}
					>
						{data?.briefIntro}
					</div>
				}
			/>
		</div>
	)
}
